import { TFunction } from 'react-i18next'
import type { ComboboxItem } from '@node-space/ui-components'
import type { Limit } from 'types/paymentLimits'
import { LimitType } from 'types/paymentLimits'

export const LIMIT_TYPE_LABELS = {
  TRANSACTION: 'paymentLimits.transactionLimit',
  DAILY: 'paymentLimits.dailyLimit',
} satisfies Record<Limit['limitType'], string>

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  SEPA_CT: 'SEPA',
  SEPA_INST: 'SEPA Instant',
  SWIFT: 'SWIFT',
  FASTER_PAYMENT: 'Faster Payment',
  ACH: 'ACH',
  FEDWIRE: 'Fedwire',
  FEDNOW: 'FedNow',
  CRNOW: 'CRNow',
  RTP: 'RTP',
}

export const CURRENCIES = ['EUR', 'GBP', 'USD'] as const

export const PAYMENT_METHOD_OPTIONS: ComboboxItem[] = Object.entries(PAYMENT_METHOD_LABELS).map(
  ([value, leftText]) => ({ value, leftText })
)

export const getPaymentMethodOptionsForCurrency = (currency: string): ComboboxItem[] => {
  switch (currency) {
    case 'EUR':
      return [
        { value: 'SEPA_CT', leftText: 'SEPA' },
        { value: 'SEPA_INST', leftText: 'SEPA Instant' },
        { value: 'SWIFT', leftText: 'SWIFT' },
      ]
    case 'GBP':
      return [
        { value: 'FASTER_PAYMENT', leftText: 'Faster Payment' },
        { value: 'SWIFT', leftText: 'SWIFT' },
      ]
    case 'USD':
      return [
        { value: 'ACH', leftText: 'ACH' },
        { value: 'FEDWIRE', leftText: 'Fedwire' },
        { value: 'CRNOW', leftText: 'CRNow' },
        { value: 'FEDNOW', leftText: 'FedNow' },
        { value: 'RTP', leftText: 'RTP' },
        { value: 'SWIFT', leftText: 'SWIFT/International Wire' },
      ]
    default:
      return []
  }
}

export const getLimitTypeOptions = (t: TFunction<'translation', undefined>) => [
  { value: LimitType.TRANSACTION, label: t('paymentLimits.transactionLimit') },
  { value: LimitType.DAILY, label: t('paymentLimits.dailyLimit') },
]

export const getAmountLabel = (
  limitType: string,
  t: TFunction<'translation', undefined>
): string => {
  if (limitType === LimitType.DAILY) return t('paymentLimits.dailyLimit')
  return t('paymentLimits.transactionLimit')
}

export const formatPaymentMethodLabel = (method: string): string => {
  return PAYMENT_METHOD_LABELS[method] ?? method.replaceAll('_', ' ')
}

